import {
  classifyDatabaseRole,
  SL_VIEW_ROLE_KEY,
} from '@streamlain/view-config';

/**
 * Locate the ViewConfig database block in a BlockSuite doc.
 *
 * The block is identified by `flavour === 'affine:database'` AND
 * role metadata. Searching by flavour alone would collide with user-owned
 * databases.
 *
 * Returns null if no such block exists.
 */
export function findViewConfigBlockId(doc: {
  root?: { children?: { id: string; flavour: string }[] } | null;
  spaceDoc?: any;
  yDoc?: any;
  getBlock?: (blockId: string) =>
    | {
        model?: { props?: Record<string, unknown> };
      }
    | undefined;
}): string | null {
  const yDoc = doc.spaceDoc ?? doc.yDoc;
  if (!yDoc) return null;
  const blocks = yDoc.getMap?.('blocks');
  if (!blocks) return null;

  let found: string | null = null;
  blocks.forEach((blockMap: any, blockId: string) => {
    if (found) return;
    const flavour = blockMap?.get?.('sys:flavour');
    if (flavour !== 'affine:database') return;
    const modelProps = doc.getBlock?.(blockId)?.model?.props as
      | Record<string, unknown>
      | undefined;
    const role = classifyDatabaseRole(
      key => blockMap?.get?.(`prop:${key}`) ?? modelProps?.[key]
    );
    const rawRole = blockMap?.get?.(`prop:${SL_VIEW_ROLE_KEY}`);
    if (role === 'config' || rawRole === 'view-config') found = blockId;
  });
  return found;
}
